import PropTypes from "prop-types";

import styled from "styled-components/macro";

import FnrInput2 from "UI/FnrInput2";

import { formatUSD } from "./helpers";

export default function AmountCheckbox({
  addOnGift,
  amount,
  donationAmount,
  active,
  disabled,
  onToggle,
  onInputClick,
  onInputChange,
  color,
}) {
  const { type, isEditable, percentage } = addOnGift;

  // const displayPercentage =
  //   type === "percentage" && !donationAmount ? `${percentage * 100}%` : null;
  const displayPercentage =
    type === "percentage" && !donationAmount
      ? `${Math.round(percentage * 100 * 100) / 100}%`
      : null;

  return (
    <Wrapper>
      <>
        {type === "flat" && isEditable ? (
          <MoneyInput
            type="currency"
            data-cy="add-on-flat-amount"
            value={amount}
            setValue={onInputChange}
            onClick={onInputClick}
            autoFocus={false}
            size="sm"
            disabled={disabled}
            $color={color}
            $borderRadius="10px"
          />
        ) : (
          <AmountAsText $color={displayPercentage ? "#9a9a9a" : color}>
            {displayPercentage || (amount > 0 ? formatUSD(amount) : "")}
          </AmountAsText>
        )}
      </>
      {/* <FnrCheckbox
        on={active}
        toggleOn={onToggle}
        color={color}
        disabled={disabled}
        checkboxSide="right"
        removeGap
      /> */}
    </Wrapper>
  );
}

AmountCheckbox.propTypes = {
  addOnGift: PropTypes.object,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  donationAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func,
  onInputClick: PropTypes.func,
  onInputChange: PropTypes.func,
  setHovering: PropTypes.func,
  color: PropTypes.string,
};

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;
  border-radius: 10px;
`;

const AmountAsText = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  font-variant-numeric: tabular-nums;
  font-family: Montserrat;
  color: ${(p) => (p.$grayedOut ? "#9a9a9a" : p.$color)};
  margin-right: 16px;
`;

const moneyInputWidth = ({ value }) => {
  let pxWidth = 72;
  if (Number(value) >= 10) {
    pxWidth = 82;
  }
  if (Number(value) >= 100) {
    pxWidth = 92;
  }
  if (Number(value) >= 1000) {
    pxWidth = 108;
  }
  return `width: ${pxWidth}px;`;
};

const MoneyInput = styled(FnrInput2)`
  position: relative;
  flex: 1;
  box-sizing: border-box;
  ${moneyInputWidth}
  font-size: 16px;
  line-height: 16px;
  height: 22px;
  font-weight: 600;
  color: ${(p) => p.$color};
  border-radius: 10px;
  background: transparent;
  border: none;
  font-variant-numeric: tabular-nums;
  font-family: Montserrat;
  appearance: none;
  text-align: left;
  margin-right: 2px;

  -webkit-transition: outline 0.6s;
  transition: outline 0.6s;
  transition: font-size 0.2s;
  transition: margin 0.6s;

  &::-moz-placeholder {
    color: #9a9a9a;
    opacity: 1;
  }
  &::placeholder {
    color: #9a9a9a;
  }
  &:focus {
    outline: 0;
  }
  &:focus-within {
    transition: border 0.2s;
    border-radius: 10px;
  }
  &:focus-within:after {
    content: "";
    position: absolute;
    top: -1px;
    right: -1px;
    bottom: -1px;
    left: -1px;
    border-radius: 10px;
    transition: border 0.2s;
    border: 2px solid ${(p) => p.$color};
  }
`;
